/**
 * Bot initialization
 *
 * Call initializeAllBots() to create bot accounts in Firebase.
 * Safe to call multiple times - skips bots that already exist.
 *
 * Usage from browser console:
 *   window.__initBots()
 *
 * Usage from code:
 *   import { initializeAllBots } from './services/bots/initializeBots';
 *   await initializeAllBots();
 */

import { initializeAllBots } from './BotService';

// Auto-initialize bot accounts (idempotent - skips existing bots)
// Also expose on window in development for manual re-runs
if (process.env.NODE_ENV === 'development') {
  (window as any).__initBots = initializeAllBots;
}
initializeAllBots().catch(() => {});

export { initializeAllBots };
